import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModularWlWysiwygEditorComponent } from 'src/app/shared/widgets/modular-wysiwyg-editor/modular-wysiwyg-editor.component';
import { SelectItem } from 'primeng/api';
import { EventEdit } from '../../shared/event-edit.model';
import { EventSignUpNotificationEmail } from '../../shared/notifications/event-signup-notification-email.model';
import { UtilService } from 'src/app/shared';
import { UserRead } from 'src/app/users/shared/user-read.model';
import { EventV4RegistrationService } from '../../shared/registration/event-v4-registration.service';
import { PlatformService } from 'src/app/shared/platform/platform.service';
import { CommunicationService } from 'src/app/communication/shared/communication.service';

@Component({
  selector: 'wl-event-v4-settings-notifications',
  templateUrl: './event-v4-settings-notifications.component.html',
  styleUrl: './event-v4-settings-notifications.component.less',
    standalone: false
})
export class EventV4SettingsNotificationsComponent implements OnInit {
  @Input() public event: EventEdit;
  @ViewChild(ModularWlWysiwygEditorComponent) private _confirmationEditor: ModularWlWysiwygEditorComponent;

  loadingConfirmationMessagePreview: boolean = false;
  specialFields: Array<SelectItem> = [];

  constructor(
    private _utilService: UtilService,
    private _registrationService: EventV4RegistrationService,
    private _platformService: PlatformService,
    private _communicationService: CommunicationService
  ) {}

  ngOnInit(): void {
    this._communicationService.getEventConfirmationEmailSpecialFields().then((specialFields) => {
      if (specialFields) {
        this.specialFields = specialFields.map<SelectItem>((field) => {
          return { label: field.name, value: field.value };
        });
      }
    });
  }

  public addNewNotificationEmail() {
    this.event.EventSignUpNotificationEmails.push(new EventSignUpNotificationEmail());
  }

  public removeNotificationEmail(notifyEmail: EventSignUpNotificationEmail) {
    this._utilService.arrayRemoveEntry(this.event.EventSignUpNotificationEmails, notifyEmail);
  }

  public selectedNotifyUserChangedHandler($event: UserRead, notifyEmail: EventSignUpNotificationEmail) {
    notifyEmail.UserNum = $event.UserNum;
    notifyEmail.FirstName = $event.FirstName;
    notifyEmail.LastName = $event.LastName;
    notifyEmail.Email = $event.Email;
  }

  /**
   * writes the confirmation editor's inlined-style HTML into event.ConfirmationMessage; await before saving
   */
  public flushEditor(): Promise<void> {
    return this._confirmationEditor?.flushInlineStyles() ?? Promise.resolve();
  }

  public previewConfirmationMessage() {
    this.loadingConfirmationMessagePreview = true;
    this._registrationService
      .getConfirmationMessagePreview(this.event.EventId)
      .then((data: string) => {
        this._platformService.openPlatformWindowToDisplayHtml(data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loadingConfirmationMessagePreview = false;
      });
  }
}
